// What each override rule does, fetched on demand.
//
// Deliberately uncached, unlike the leaf grid. The grid is a property of the
// trees and does not change while the page is open; these counts change whenever
// a rule is edited, the weights move or the thresholds move, so a cache here
// would show the previous answer with the confidence of the current one.
import axios from 'axios';

export interface RuleImpact {
  /** The rule's position in the stored list, which the editor numbers from. */
  ruleIndex: number;
  /** Leads this rule decided the segment for. */
  matched: number;
  /** Of those, the ones whose segment it actually changed. */
  moved: number;
  /** Conversions among the moved leads. */
  movedConversions: number;
}

/**
 * One entry per rule that decided at least one lead's segment, or null if the
 * counts could not be produced.
 *
 * Null rather than an empty array, because the two mean different things: an
 * empty array is "every rule moved nothing", which is a finding, while a failed
 * read is not. The caller shows nothing at all in the second case rather than
 * labelling every rule with a zero it did not earn.
 */
export function fetchOverrideImpact(
  tenant: string | number,
  modelId: string | number
): Promise<RuleImpact[] | null> {
  return axios
    .get(`/api/tenant/${tenant}/model/${modelId}/overrides/impact`)
    .then(({ data }) => (Array.isArray(data) ? (data as RuleImpact[]) : null))
    .catch(() => null);
}
